var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_do_lobster-roll-cli_runtime_browser_js-node_modules_lodash_cloneDeep_js--5d8fbb"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react-router_react-router"), __webpack_require__.e("webpack_sharing_consume_default_react-helmet_react-helmet-webpack_sharing_consume_default_rea-34e127"), __webpack_require__.e("build_node_components_AvatarDropdown_js-build_node_components_Copilot_CopilotTrigger_js-build-5e566e"), __webpack_require__.e("build_node_library_js")]).then(() => (() => ((__webpack_require__("./build/node/library.js")))));
	},
	"./navigation": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react-router_react-router"), __webpack_require__.e("webpack_sharing_consume_default_react-helmet_react-helmet-webpack_sharing_consume_default_rea-34e127"), __webpack_require__.e("build_node_navigation_js")]).then(() => (() => ((__webpack_require__("./build/node/navigation.js")))));
	},
	"./mount": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_do_lobster-roll-cli_runtime_browser_js-node_modules_lodash_cloneDeep_js--5d8fbb"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react-router_react-router"), __webpack_require__.e("webpack_sharing_consume_default_react-helmet_react-helmet-webpack_sharing_consume_default_rea-34e127"), __webpack_require__.e("build_node_components_AvatarDropdown_js-build_node_components_Copilot_CopilotTrigger_js-build-5e566e"), __webpack_require__.e("build_node_mount_js")]).then(() => (() => ((__webpack_require__("./build/node/mount.js")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});